import React from "react";

export default function About() {
    return (
        <section className="flat-spacing-3 pb-0">
            <div className="container">
                <div className="flat-title-2 d-xl-flex justify-content-xl-between">
                    <div className="box-title">
                        <p className="display-lg-2 fw-medium">Welcome to Lux & Co</p>
                        <p className="text-xl">Where Style Meets Substance</p>
                    </div>
                    <div className="box-text">
                        <p className="text-md">
                            At <span className="fw-medium"> Lux & Co</span>, we believe that true elegance lies in simplicity, quality, and timeless
                            design. <br className="d-none d-xl-block"/>Founded with a passion for refined fashion, we bring together carefully selected
                            fabrics, <br className="d-none d-xl-block"/>clean lines, and contemporary aesthetics to create pieces that speak to confident,
                            modern individuals.
                        </p>
                    </div>
                </div>
                {/*<div className="image radius-16 overflow-hidden">*/}
                {/*    <img*/}
                {/*        src="/images/section/about.jpg"*/}
                {/*        data-=""*/}
                {/*        alt=""*/}
                {/*        className="lazyload"*/}
                {/*        width={1440}*/}
                {/*        height={502}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </section>
    );
}
